var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirebase1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 120,
    viewBox: "0 0 240 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 120
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_27",
    "data-name": 27,
    clipPath: "url(#clip-_27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20042",
    "data-name": "Group 20042",
    transform: "translate(9 7.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "firebase-seeklogo.com",
    transform: "translate(30 20.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111341",
    "data-name": "Path 111341",
    d: "M0,51.477l.386-.541L18.649,16.282l.039-.367L10.637.793a1.494,1.494,0,0,0-2.795.472Z",
    transform: "translate(0 0)",
    fill: "#ffc24a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20040",
    "data-name": "Group 20040",
    transform: "translate(0.228 0.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111342",
    "data-name": "Path 111342",
    d: "M1.253,52.129l.292-.57L19.617,17.269,11.586,2.085A1.357,1.357,0,0,0,9,2.554Z",
    transform: "translate(-1.253 -1.301)",
    fill: "#ffa712"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111343",
    "data-name": "Path 111343",
    d: "M1.253,52.129l.292-.57L19.617,17.269,11.586,2.085A1.357,1.357,0,0,0,9,2.554Z",
    transform: "translate(-1.253 -1.301)",
    fill: "#ffa713"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_111344",
    "data-name": "Path 111344",
    d: "M108.348,67.625l5.994-6.139-6-11.447a1.545,1.545,0,0,0-2.722,0l-3.2,6.11v.52Z",
    transform: "translate(-83.791 -40.271)",
    fill: "#f4bd62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20041",
    "data-name": "Group 20041",
    transform: "translate(18.688 9.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111345",
    "data-name": "Path 111345",
    d: "M108.5,68.411l5.828-5.968-5.828-11.1a1.342,1.342,0,0,0-2.445-.107l-3.221,6.2-.1.317Z",
    transform: "translate(-102.739 -50.499)",
    fill: "#ffa50e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111346",
    "data-name": "Path 111346",
    d: "M108.5,68.411l5.828-5.968-5.828-11.1a1.342,1.342,0,0,0-2.445-.107l-3.221,6.2-.1.317Z",
    transform: "translate(-102.739 -50.499)",
    fill: "#ffa50d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_111347",
    "data-name": "Path 111347",
    d: "M0,122.737l.175-.176.636-.258L24.181,99.02l.3-.806L18.647,87.1Z",
    transform: "translate(0 -71.261)",
    fill: "#f6820c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111348",
    "data-name": "Path 111348",
    d: "M25.306,121.737l21.15-11.8-6.04-37.2a1.445,1.445,0,0,0-2.45-.789L0,109.995l21.029,11.741a4.389,4.389,0,0,0,4.277,0",
    transform: "translate(0 -58.518)",
    fill: "#fde068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111349",
    "data-name": "Path 111349",
    d: "M47.321,110.64,41.328,73.725a1.27,1.27,0,0,0-2.2-.8L1.289,110.72l20.8,11.625a4.355,4.355,0,0,0,4.244,0Z",
    transform: "translate(-1.055 -59.315)",
    fill: "#fcca3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111350",
    "data-name": "Path 111350",
    d: "M25.306,292.719a4.389,4.389,0,0,1-4.277,0L.17,281.145,0,281.324l21.029,11.741a4.389,4.389,0,0,0,4.277,0l21.15-11.8-.052-.319Z",
    transform: "translate(0 -229.847)",
    fill: "#eeab37"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Firebase",
    transform: "translate(84 66.236)",
    fill: "#646464",
    fontSize: 28,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Firebase"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase1);
export default __webpack_public_path__ + "static/media/firebase-1.36d56d938a00302d59a375d5251a48a3.svg";
export { ForwardRef as ReactComponent };